import React from 'react';
import '../../styles/project.css'; // Import Project specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const ProjectServices = () => {
  return (
    <>
      {/* Project Services Section */}
      <section id="project-services" className="about-preview-section">
        <div className="container">
          <div className="about-content-wrapper">
            <div className="about-text-content">
              <div className="section-badge">WHAT WE PROVIDE</div>
              <h2 className="section-title">Our Project Services</h2>
              <p className="section-description">
                Our comprehensive project cargo services handle complex logistics challenges 
                with specialized equipment and expert planning. We deliver tailor-made solutions 
                for oversized cargo, special events, and unique transportation requirements.
              </p>
              <p className="section-description">
                From heavy machinery to event logistics, our team ensures precise handling 
                and timely delivery. We treat each project as a partnership, developing 
                customized solutions that address your specific operational needs.
              </p>
              
              <div className="hero-actions mt-4">
                <a href="/contactUs" className="btn-primary-hero">Get Started</a>
              </div>
            </div>
            <div className="about-image-content">
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-industry"></i>
                  </div>
                  <span className="stat-number">Heavy Cargo</span>
                  <div className="stat-label">Oversized equipment transport</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-calendar-alt"></i>
                  </div>
                  <span className="stat-number">Event Logistics</span>
                  <div className="stat-label">Special events coordination</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-cogs"></i>
                  </div>
                  <span className="stat-number">Custom Solutions</span>
                  <div className="stat-label">Tailored project planning</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <span className="stat-number">24/7 Support</span>
                  <div className="stat-label">Round-the-clock monitoring</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectServices;
